import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PACKAGE_LIST } from '../data/packages';
export function Magazin() {
  return <div className="w-full" data-id="element-413">
      <section className="bg-navy diagonal-pattern py-24 px-6" data-id="element-414">
        <div className="max-w-7xl mx-auto" data-id="element-415">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-416">
            <div className="text-gold font-label text-xs uppercase tracking-label mb-4" data-id="element-417">
              Servicii Juridice
            </div>
            <h1 className="text-text-light font-heading text-4xl md:text-6xl font-bold mb-6" data-id="element-418">
              Alege pachetul potrivit pentru{' '}
              <span className="text-gold" data-id="element-419">situația ta</span>
            </h1>
            <p className="text-text-light-secondary font-body text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-420">
              Fiecare pachet pornește de la aceeași Sesiune de Claritate. Dacă
              nu știi de unde să începi, rezervă mai întâi sesiunea de
              consultanță și stabilim împreună drumul potrivit.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-421">
            {PACKAGE_LIST.map((pkg, index) => <motion.div key={pkg.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index % 3 * 0.1
          }} className="bg-dark-card rounded-xl overflow-hidden border-t-[3px] border-gold flex flex-col" data-id="element-422">
                <div className="relative h-48 overflow-hidden" data-id="element-423">
                  <img src={pkg.image} alt={pkg.hero.title} className="w-full h-full object-cover" data-id="element-424" />
                  <div className="absolute inset-0 bg-navy/30" data-id="element-425"></div>
                  <span className="absolute top-4 left-4 bg-gold text-navy font-label text-[10px] uppercase tracking-label px-3 py-1.5 rounded" data-id="element-426">
                    {pkg.badge}
                  </span>
                </div>

                <div className="p-6 flex flex-col flex-1" data-id="element-427">
                  <h3 className="text-text-light font-heading text-2xl font-bold mb-3" data-id="element-428">
                    {pkg.hero.title}
                  </h3>
                  <p className="text-text-light-secondary font-body text-sm leading-relaxed mb-6 flex-1" data-id="element-429">
                    {pkg.shortDescription}
                  </p>
                  <Link to={`/${pkg.slug}`} className="inline-flex items-center justify-center gap-2 bg-gold text-navy px-6 py-3 rounded font-label text-xs uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-430">
                    Vezi detalii
                    <ArrowRightIcon className="w-4 h-4" strokeWidth={2} data-id="element-431" />
                  </Link>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-cream py-20 px-6" data-id="element-432">
        <div className="max-w-3xl mx-auto text-center" data-id="element-433">
          <h2 className="text-text-dark font-heading text-3xl md:text-4xl font-bold mb-6" data-id="element-434">
            Nu știi ce pachet ți se potrivește?
          </h2>
          <p className="text-text-dark-secondary font-body text-lg leading-relaxed mb-8" data-id="element-435">
            Rezervă Sesiunea de Claritate de 150 EUR + TVA. Îți explic exact ce
            poți obține și stabilim împreună pachetul potrivit. Suma se aplică
            integral la pachetul ales dacă decidem să continuăm.
          </p>
          <Link to="/contact" className="inline-block bg-gold text-navy px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-436">
            Rezervă Sesiunea de Claritate
          </Link>
        </div>
      </section>
    </div>;
}